import type { SVGProps } from "react";
export const MarkAsReadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="m4.75 6.051 6.999 4.374 6.998-4.374zm0 12.248q-.721 0-1.236-.514A1.69 1.69 0 0 1 3 16.549V6.051q0-.721.514-1.236a1.69 1.69 0 0 1 1.236-.514h13.997q.722 0 1.236.514t.514 1.236v4.374a.85.85 0 0 1-.252.624.85.85 0 0 1-.623.251.85.85 0 0 1-.623-.251.85.85 0 0 1-.252-.624V7.801l-6.54 4.09q-.064.043-.459.13a.909.909 0 0 1-.46-.131L4.751 7.8v8.75H9.56q.372 0 .624.25a.85.85 0 0 1 .251.624.85.85 0 0 1-.251.623.85.85 0 0 1-.624.252zm10.454-.7 4.33-4.33a.83.83 0 0 1 .613-.241.83.83 0 0 1 .612.24q.24.24.241.613a.83.83 0 0 1-.24.612l-4.944 4.943a.84.84 0 0 1-.612.263.84.84 0 0 1-.612-.263l-2.494-2.493a.83.83 0 0 1-.24-.613.83.83 0 0 1 .24-.612.83.83 0 0 1 .613-.24.83.83 0 0 1 .612.24z"
    />
  </svg>
);
